// PageTitle — a Studio page's title, written on the paper (owner, 29 Oct):
// a click puts the caret in it, nothing moves, leaving keeps the new name
// (one line, spaces tidied; an empty or unchanged name sends nothing). A
// page that cannot be renamed here (the project's own page, or offline)
// shows the title as text. Pure: a new name goes out as an intent.

export { PageTitle };

import * as Limits from "@bilda/core/limits";
import { useLingui } from "@lingui/react/macro";
import type { ReactNode } from "react";
import { EditableText } from "../Editor/EditableText/EditableText.js";

const PageTitle = ({
    title,
    onRename,
}: {
    readonly title: string;
    // Absent: not renamed here.
    readonly onRename: ((title: string) => void) | undefined;
}): ReactNode => {
    const { t } = useLingui();
    return (
        <h1 className="bilda-pages__page-title" title={title}>
            {onRename === undefined ? (
                title
            ) : (
                <EditableText
                    value={title}
                    ariaLabel={t`Title`}
                    maxLength={Limits.SHORT_TEXT_MAX}
                    onCommit={(text) => {
                        const next = text.replace(/\s+/g, " ").trim();
                        if (next !== "" && next !== title) onRename(next);
                    }}
                />
            )}
        </h1>
    );
};
